import LangSelect from "@/components/langSelect";
import { REPOSITORY_OPTIONS } from "@/views/statement/config.js";

const USER_NAME_PLACEHOLDER = "{{user_name}}";
const AGENT_NAME_PLACEHOLDER = "{{agent_name}}";

export default {
    name: "StatementDetailPane",
    props: {
        contentInputRef: String,
        title: String,
        btnTitle: String,
        btnType: {
            type: String,
            default: "primary"
        },
        data: {
            type: Object,
            default: () => {
                return {};
            }
        },
        contentAutofocus: {
            type: Boolean,
            default: false
        }
    },
    components: {
        LangSelect
    },
    data() {
        return {
            showDrawer: false,
            rules: {
                repository: [{ required: true, message: this.$t("statement.repositoryTypeValidate"), trigger: "change" }],
                language: [{ required: true, message: this.$t("statement.languageValidate"), trigger: "change" }],
                type_id: [{ required: true, message: this.$t("statement.statementTypeValidate"), trigger: "change" }]
            },
            form: Object.assign(
                {
                    repository: null,
                    language: "",
                    type_id: "",
                    content: ""
                },
                this.data
            )
        };
    },
    computed: {
        repositoryOptions() {
            return REPOSITORY_OPTIONS;
        },
        typeOptions() {
            return this.$store.state.statement.statementType.stmtTypeList.map(type => ({
                label: type.name,
                value: type.id
            }));
        },
        loading() {
            return this.$store.state.statement.statement.processing;
        }
    },
    methods: {
        handleOpen() {
            this.showDrawer = true;
            this.form = Object.assign(
                {
                    repository: null,
                    language: "",
                    type_id: "",
                    content: ""
                },
                this.data
            );
        },
        handleClose() {
            this.$refs.form.resetFields();
            this.showDrawer = false;
        },
        handleSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$store.commit("statement/updateProcessStatus", true);
                    let params = this.form;
                    if (!this.data.id) {
                        this.$store
                            .dispatch("statement/addStmt", params)
                            .then(() => {
                                this.$store.commit("statement/updateProcessStatus", false);
                                this.handleClose();
                            })
                            .catch(() => {
                                this.$store.commit("statement/updateProcessStatus", false);
                            });
                    } else {
                        params.statement_id = this.data.id;
                        this.$store
                            .dispatch("statement/updateStmt", params)
                            .then(() => {
                                this.$store.commit("statement/updateProcessStatus", false);
                                this.handleClose();
                            })
                            .catch(() => {
                                this.$store.commit("statement/updateProcessStatus", false);
                            });
                    }
                } else {
                    return false;
                }
            });
        },
        handleAddUserNick() {
            this.insertInputText(USER_NAME_PLACEHOLDER);
        },
        handleAddCustomerNick() {
            this.insertInputText(AGENT_NAME_PLACEHOLDER);
        },
        insertInputText(insertText) {
            const elInput = this.$refs[this.contentInputRef].$refs.textarea;
            const startPos = elInput.selectionStart;
            const endPos = elInput.selectionEnd;
            if (startPos === undefined || endPos === undefined) {
                return;
            }
            let txt = elInput.value;
            let result = txt.substring(0, startPos) + insertText + txt.substring(endPos);
            this.form.content = result;
            elInput.focus();
            elInput.selectionStart = startPos + insertText.length;
            elInput.selectionEnd = startPos + insertText.length;
        }
    }
};
